import {combineReducers, createStore} from 'redux'

const rootReducer = combineReducers({

    
        auth: function(state, action) {

            console.log(action.payload)

            switch (action.type) {
                case 'AUTH':
                    return {
                        ...state,
                        authenticated: true,
                        keycloak: action.payload.keycloak,
                        userInfo: action.payload.userInfo
                    }
                case 'LOGOFF':
                    return {
                        keycloak: null,
                        authenticated: false,
                        userInfo: null,
                    }
                default:
                    return {
                        keycloak: null,
                        authenticated: false,
                        userInfo: null
                    }
            }
        },
        config: function(state, action) {
            return {
                API_HOST: 'https://api-mural.ariquemes.ifro.edu.br'
            }
        }
        

})

function storeConfig() {
    return createStore(rootReducer)
}

export default storeConfig